import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '../Select';
import { SaveErrorPropType } from '../../../../proptypes/errors';
import { selectAllNurseDeploymentFixations, indexNurseDeploymentFixations } from '../../../nurseDeploymentFixation/nurseDeploymentFixationSlice';

const NurseDeploymentFixationSelect = ({ ...other }) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexNurseDeploymentFixations());
    }, [dispatch]);

    const nurseDeploymentFixations = useSelector(selectAllNurseDeploymentFixations);
    const options = useMemo( () => {

        return nurseDeploymentFixations.map(({ id, fixedAt, fixationMonth }) => {

            const monthName = fixationMonth ? new Date(fixationMonth).toLocaleString('de-DE', { month: 'long' }) : '';
            const fixedatdate = fixedAt ? new Date(fixedAt).toLocaleDateString('de-DE') : '';
            //console.log('NurseDeploymentFixationSelect options', { id, fixedAt, fixationMonth, monthName, fixedatdate });

            return {
                value: id,
                label:  'Fixierter Monat: ' + monthName + '   [Fixiert am ' + fixedatdate + ']',
            };
        });
    },
        [nurseDeploymentFixations]
    );

    return <Select {...other} options={options} />;
};

NurseDeploymentFixationSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    labelId: PropTypes.string,
    onChange: PropTypes.func,
    errors: SaveErrorPropType,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

NurseDeploymentFixationSelect.defaultProps = {
    label: null,
    labelId: null,
    onChange: null,
    errors: null,
    fullWidth: false,
    disabled: false,
    loading: false,
};

export default NurseDeploymentFixationSelect;